module.exports = __webpack_public_path__ + "static/trig_007-2fa4a42127aa59d9a9baeb8a15c3778c.webp";